module.exports = __webpack_public_path__ + "static/media/osmosisart.8fe74179.png";